<div>
  <input id="toggle-sidebar-checkbox" type="checkbox" role="button" class="toggle-sidebar-checkbox" />
  <label for="toggle-sidebar-checkbox" class="toggle-sidebar"></label>

  <div class="sidebar" [ngClass]="{ hide: mapMobileMenu.mapActive }">
    <aa-route-input (showRouteEvent)="onShowRoute()"></aa-route-input>
    <aa-route-via-list></aa-route-via-list>
    <aa-route-options></aa-route-options>
    <aa-route-plan-button [title]="'Plan route'" (click)="onShowRoute($event)"></aa-route-plan-button>
    <aa-route-print-button type="route"></aa-route-print-button>
    <aa-route-summary></aa-route-summary>

    <!-- Mobile : Navigate button -->
    <aa-route-navigate></aa-route-navigate>
    <aa-route-signposts></aa-route-signposts>
  </div>

  <div class="content border-0" [ngClass]="mapMobileMenu.mapActive ? 'show' : 'route-planner-map'">
    <div class="map-container">
      <aa-hybrid-google-map #aaMap [mapType]="0"></aa-hybrid-google-map>
      @if (isDesktop) {
        <aa-traffic-alert-last-updated></aa-traffic-alert-last-updated>
      }
    </div>
  </div>
</div>

<!-- Mobile View -->
@if (!isDesktop) {
  <div class="ads-sticky-mobile">
    <aa-app-advertisement class="ads-sticky-mobile" type="the-aa-mpu-mobile"></aa-app-advertisement>
  </div>
}
